export default "__VITE_ASSET__DHFGfy85__"